import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Card, CardContent, Grid, Typography } from "@mui/material";

const FarmSummaryCard = ({ farmSummary, handleFarmView }) => {
  const { t } = useTranslation();
  return (
    <Card fullWidth>
      <CardContent fullWidth>
        <Grid container spacing={1}>
          <Grid item xs={8}>
            {Object.keys(farmSummary).map((key) => {
              return key == "id" ? null : (
                <Typography key={key}>
                  <strong>{key}</strong> : {farmSummary[key]}
                </Typography>
              );
            })}
          </Grid>
          {handleFarmView && (
            <Grid item xs={3}>
              <Button
                variant="contained"
                onClick={() => handleFarmView(farmSummary.id)}
              >
                {t("View Farm")}
              </Button>
            </Grid>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default FarmSummaryCard;
